export default function useRouteURL(
  route: MaybeRefOrGetter<{ fullPath: string }>,
) {
  return computed(() =>
    normalizeUrl(new URL(toValue(route).fullPath, useRequestURL().origin)),
  )
}
